<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>
      <div class="center">{{title}}</div>
      <div class="right" @click="toHome()">
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="padding content" v-if="type==1">
      <van-field v-model="unit_name" required clearable label="真实姓名" placeholder="请输入真实姓名" />
      <van-field name="uploader" required label="上传照片">
        <template #input>
          <van-uploader
            v-model="uploader"
            :max-count="1"
            :after-read="afterRead"
            @delete="deleteImg"
          />
        </template>
      </van-field>
      <van-field name="radio" label="性别" required>
        <template #input>
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio name="1" checked-color="#6DCC13">男</van-radio>
            <van-radio name="2" checked-color="#6DCC13">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="telphone" required clearable label="手机号" placeholder="请输入手机号" />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value"
        label="可服务时间"
        placeholder="点击选择"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value2"
        label="可服务时段"
        placeholder="点击选择"
        @click="showPicker2 = true"
      />
      <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value3"
        label="服务类别"
        placeholder="点击选择"
        @click="showPicker3 = true"
      />
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns3"
          @confirm="onConfirm3"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value4"
        label="专业或特长"
        placeholder="点击选择"
        @click="showPicker4 = true"
      />
      <van-popup v-model="showPicker4" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns4"
          @confirm="onConfirm4"
          @cancel="showPicker4 = false"
        />
      </van-popup>
      <div class="comfirm-btn" @click="toSubmit()">提交</div>
    </div>
    <div class="padding content" v-if="type==2">
      <van-field v-model="team_name" required clearable label="志愿团队名称" placeholder="请输入志愿团队名称" />
      <van-field v-model="admin_name" required clearable label="联系人姓名" placeholder="请输入联系人姓名" />
      <van-field v-model="admin_telephone" required clearable type="tel" label="联系人手机号" placeholder="请输入联系人手机号" />
      <van-field v-model="team_number" required clearable type="digit" label="团队人数" placeholder="请输入团队人数" />
      <van-field
        v-model="team_description"
        required
        rows="4"
        autosize
        label="团队简要概述"
        type="textarea"
        maxlength="100"
        placeholder="请输入团队简要概述"
        show-word-limit
      />
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value"
        label="可服务时间"
        placeholder="点击选择"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value2"
        label="可服务时段"
        placeholder="点击选择"
        @click="showPicker2 = true"
      />
      <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value3"
        label="服务类别"
        placeholder="点击选择"
        @click="showPicker3 = true"
      />
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns3"
          @confirm="onConfirm3"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-field
        readonly
        required
        clickable
        name="picker"
        :value="value4"
        label="专业或特长"
        placeholder="点击选择"
        @click="showPicker4 = true"
      />
      <van-popup v-model="showPicker4" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns4"
          @confirm="onConfirm4"
          @cancel="showPicker4 = false"
        />
      </van-popup>
      <div class="comfirm-btn" @click="toSubmit()">提交</div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">确定要提交吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import {
  Icon,
  Field,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Uploader,
  Popup,
  Picker,
} from "vant";
import { helpJob, uploadImages, helpVolunteer, helpGroup } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      info: [],
      type: "",
      unit_name: "",
      position: "",
      contacts_name: "",
      contacts_telphone: "",
      category: "",
      recruit_number: "",
      salary: "",
      work_time: "",
      radio: "1",
      has_social_security: "",
      show: false,
      title: "",
      uploader: [],
      value: "",
      columns: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      showPicker: false,
      value2: "",
      columns2: ["早上", "中午", "下午"],
      showPicker2: false,
      value3: "",
      columns3: [
        "法律咨询",
        "维权服务",
        "心里健康",
        "文体活动",
        "消防安全",
        "家教",
        "读报聊天",
        "打扫卫生",
        "买菜烧菜",
        "搀扶出行",
        "洗衣服",
        "采购日用品",
        "生活料理",
        "家电维修",
        "理发",
        "教学",
        "其它",
      ],
      showPicker3: false,
      value4: "",
      columns4: [
        "法律",
        "心里咨询师",
        "手语翻译师",
        "语文",
        "数学",
        "英语",
        "语法",
        "绘画",
        "唱歌",
        "葫芦丝",
        "钢琴",
        "古筝",
        "二胡",
        "萨克斯",
        "腰鼓",
        "舞蹈",
        "走秀",
        "小品演讲",
        "朗诵",
        "节目主持",
        "摄影",
        "电脑维修",
        "护理",
        "家政",
        "其他",
      ],
      showPicker4: false,
      images: "", //图片
      imagesArr: [],
      telphone: "",
      team_name: "",
      admin_name: "",
      admin_telephone: "",
      team_number: "",
      team_description: "",
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let type = this.$route.query.type;
    this.type = type;
    if (type == 1) {
      this.title = "志愿者个人注册";
    } else if (type == 2) {
      this.title = "志愿者团队注册";
    }
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      // this.$router.push("/index");
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toSubmit() {
      if (this.type == 1) {
        if (this.unit_name == "") {
          Toast("请输入真实姓名");
        } else if (this.imagesArr.length == 0) {
          Toast("请上传照片");
        }else if (!/^1[34578]\d{9}$/.test(this.telphone)) {
          Toast("请输入正确电话号码");
        } else if (this.value == "") {
          Toast("请选择服务时间");
        } else if (this.value2 == "") {
          Toast("请选择服务时段");
        } else if (this.value3 == "") {
          Toast("请选择服务类别");
        } else if (this.value4 == "") {
          Toast("请选择专业或特长");
        }  else {
          this.show = true;
        }
      } else {
        if (this.team_name == "") {
          Toast("请输入志愿团队名称");
        } else if (this.admin_name == "") {
          Toast("请输入联系人姓名");
        } else if (!/^1[34578]\d{9}$/.test(this.admin_telephone)) {
          Toast("请输入正确手机号");
        } else if (this.team_number == "") {
          Toast("请输入团队人数");
        } else if (this.team_description == "") {
          Toast("请输入团队简要概述");
        } else if (this.value == "") {
          Toast("请选择服务时间");
        } else if (this.value2 == "") {
          Toast("请选择服务时段");
        } else if (this.value3 == "") {
          Toast("请选择服务类别");
        } else if (this.value4 == "") {
          Toast("请选择专业或特长");
        }  else {
          this.show = true;
        }
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.type == 1) {
          if (this.radio == 1) {
            this.has_social_security = "男";
          } else {
            this.has_social_security = "女";
          }
          this.images = this.imagesArr.toString();
          var parm = {
            true_name: this.unit_name,
            avatar: this.images,
            gender: this.has_social_security,
            telphone: this.telphone,
            service_work: this.value,
            service_time: this.value2,
            service_type: this.value3,
            skills: this.value4,
          };
          helpVolunteer(parm).then((res) => {
            Toast(res.message);
            if (res.status == 1) {
              this.$router.push({
                path: "/successful",
                query: {
                  type: 1,
                },
              });
            }
          });
        } else {
          var parm = {
            team_name: this.team_name,
            admin_name: this.admin_name,
            admin_telephone: this.admin_telephone,
            team_number: this.team_number,
            service_work: this.value,
            service_time: this.value2,
            service_type: this.value3,
            skills: this.value4,
            team_description: this.team_description,
          };
          helpGroup(parm).then((res) => {
            Toast(res.message);
            if (res.status == 1) {
              this.$router.push({
                path: "/successful",
                query: {
                  type: 1,
                },
              });
            }
          });
        }
      } else {
        done();
      }
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    onConfirm2(value) {
      this.value2 = value;
      this.showPicker2 = false;
    },
    onConfirm3(value) {
      this.value3 = value;
      this.showPicker3 = false;
    },
    onConfirm4(value) {
      this.value4 = value;
      this.showPicker4 = false;
    },
    afterRead(file) {
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        // let cal = 1024*1024/file.file.size; //计算比例，也可以自己定义比例 0.5等等
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          //最大高度
          const maxHeight = 500;
          //最大宽度
          const maxWidth = 500;
          // 指定canvas画布大小，该大小为最后生成图片的大小
          const originHeight = img.height;
          const originWidth = img.width;
          let compressedWidth = img.height;
          let compressedHeight = img.width;
          if (originWidth > maxWidth && originHeight > maxHeight) {
            // 更宽更高，
            if (originHeight / originWidth > maxHeight / maxWidth) {
              // 更加严重的高窄型，确定最大高，压缩宽度
              compressedHeight = maxHeight;
              compressedWidth = maxHeight * (originWidth / originHeight);
            } else {
              //更加严重的矮宽型, 确定最大宽，压缩高度
              compressedWidth = maxWidth;
              compressedHeight = maxWidth * (originHeight / originWidth);
            }
          } else if (originWidth > maxWidth && originHeight <= maxHeight) {
            // 更宽，但比较矮，以maxWidth作为基准
            compressedWidth = maxWidth;
            compressedHeight = maxWidth * (originHeight / originWidth);
          } else if (originWidth <= maxWidth && originHeight > maxHeight) {
            // 比较窄，但很高，取maxHight为基准
            compressedHeight = maxHeight;
            compressedWidth = maxHeight * (originWidth / originHeight);
          } else {
            // 符合宽高限制，不做压缩
          }
          canvas.height = compressedHeight;
          canvas.width = compressedWidth;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存到数组中，留待上传。
          var parm = {
            file: file.content,
          };
          uploadImages(parm).then((res) => {
            this.imagesArr.push(res.data[0]);
          });
        };
      } else {
        var parm = {
          file: file.content,
        };
        uploadImages(parm).then((res) => {
          this.imagesArr.push(res.data[0]);
        });
      }
      // var parm = {
      //   file: file.content
      // };
      // // this.imagesArr = [1, 2, 3, 4, 5]
      // uploadImages(parm).then(res => {
      //   this.imagesArr.push(res.data[0]);
      // });
    },
    deleteImg(file, name) {
      var index = name.index;
      this.imagesArr.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
.comfirm-btn {
  width: 95%;
  margin: 0 auto;
  background: #6dcc13;
  height: 2.5rem;
  line-height: 2.5rem;
  color: white;
  text-align: center;
  margin-top: 2rem;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/page/helpVolunteer.vue